module.exports = __webpack_public_path__ + "img/FR.f3b8142f.svg";